import { errorHandler, loadersSlice, notifyMessageCreator } from 'Modules'
import { get } from 'lodash'
import { call, put, takeEvery } from 'typed-redux-saga'
import { ResponseCatalog, FormErrorModel } from 'Models'
import { questionApi, QuestionNS, QuestionModel, questionSlice, surveySlice } from 'Pages/survey'

function* getOne(action: QuestionNS.GetOne) {
	try {
		const res = yield* call(questionApi.getOne, action.payload)
		const current = new ResponseCatalog<QuestionModel>()
		current.entries = [res]
		yield* put(questionSlice.actions.setOne(current))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* createOne(action: QuestionNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { callback, data } = action.payload
		const res = yield* call(questionApi.createOne, data)
		yield* call(notifyMessageCreator, 'common.question_create.success', { data: [res.text] })
		callback?.()
		yield* put(surveySlice.actions.getOne(+res.survey_id))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateOne(action: QuestionNS.UpdateOne) {
	try {
		const { callback, data } = action.payload
		const res = yield* call(questionApi.updateOne, data)
		yield* call(notifyMessageCreator, 'common.question_update.success', { data: [res.text] })
		callback?.()
		yield* put(surveySlice.actions.getOne(+res.survey_id))
	} catch (error) {
		yield* call(errorHandler, error)
		const reducedErr = get(error, 'data.errors', []).reduce((obj, item): FormErrorModel => {
			return { ...obj, ...item }
		}, {})
		yield* put(questionSlice.actions.setFromError(reducedErr))
	}
}

function* deleteOne(action: QuestionNS.DeleteOne) {
	try {
		const { survey_id, id, callback } = action.payload
		yield* call(questionApi.deleteOne, id)
		yield* call(notifyMessageCreator, 'common.question_delete.success')
		callback?.()
		yield* put(surveySlice.actions.getOne(survey_id))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const questionSaga = function* saga() {
	yield* takeEvery(questionSlice.actions.getOne.type, getOne)
	yield* takeEvery(questionSlice.actions.createOne.type, createOne)
	yield* takeEvery(questionSlice.actions.updateOne.type, updateOne)
	yield* takeEvery(questionSlice.actions.deleteOne.type, deleteOne)
}
